"use client";

import React, { useEffect } from "react";
import { Button } from "antd";
import Title from "antd/lib/typography/Title";
import Paragraph from "antd/lib/typography/Paragraph";
import AppContentWrapper from "@/app/components/AppContentWrapper";

interface RouteErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
  title?: string;
  description?: string;
}

/**
 * Shared route-level error boundary UI. Renders a friendly fallback instead of
 * letting a server render throw bubble up as a raw FUNCTION_INVOCATION_FAILED.
 */
const RouteError: React.FC<RouteErrorProps> = ({
  error,
  reset,
  title = "Something went wrong",
  description = "We hit an unexpected error loading this page. Please try again in a moment.",
}) => {
  useEffect(() => {
    // Surface to the platform logs for observability.
    console.error(error);
  }, [error]);

  return (
    <AppContentWrapper>
      <Title level={4}>{title}</Title>
      <Paragraph>{description}</Paragraph>
      <Button type="primary" onClick={reset}>
        Try again
      </Button>
    </AppContentWrapper>
  );
};

export default RouteError;
